import React from "react";
import UserDetailsHeader from "../../../UserDetailsHeader";
import { Typography } from "@mui/material";
// import videothumbnailIcon from "../../../../../assets/images/HowtoTestVideoThumbnail.svg";
import "../../tug/howToTest/howToTest.scss";
import { getParams } from "../../../../../utlis/helpers";
import prerequisitesImg from "../../../../../assets/images/HowToTest/GaitBalance/prerequisites.png";
import setupImg from "../../../../../assets/images/HowToTest/GaitBalance/setup.png";
import setupForJP from "../../../../../assets/images/HowToTest/GaitBalance/setupForJP.png";
import performTestImg from "../../../../../assets/images/HowToTest/GaitBalance/performTest.png";
import uploadImg from "../../../../../assets/images/HowToTest/TugFront/upload.png";
import uploadForJP from "../../../../../assets/images/HowToTest/TugFront/uploadForJP.png";
import { pageLocale } from "../../../../../utlis/locale";

const HowtoTestGaitAndBalance = () => {
  const { locale } = getParams();
  const { phone_stand_desc, support_desc, upload1, upload2 } =
    pageLocale("tugFront");
  const {
    how_to,
    phone_stand,
    support_person,
    step_guide,
    step_one,
    step_two,
    step_three,
    step_four,
    disable_wide,
    disable_wide_desc,
  } = pageLocale("common");
  const { setup1, setup2, setup3, setup4, perform1, perform2, setupnewAdd } =
    pageLocale("g&b");
  const getInfo = JSON.parse(sessionStorage.getItem("testDescription"));
  const prerequisitesStepsItem = [
    {
      title: phone_stand,
      description: phone_stand_desc,
    },
    {
      title: support_person,
      description: support_desc,
    },
    {
      title: disable_wide,
      description: disable_wide_desc,
    },
  ];
  return (
    <UserDetailsHeader>
      <div className="how-to-test-main-wrapper">
        <Typography className="title">
          {getInfo?.moduleName}: {how_to}
        </Typography>
        <div className="test-instruction-wrapper">
          {/* <Typography className="test-instruction-title">
            Watch and Learn: Video Playlist
          </Typography>
          {playlistItem?.map((item, index) => {
            return (
              <div className="video-playlist" key={index}>
                <div>
                  <img src={videothumbnailIcon} alt="thumbnail" />
                </div>
                <div>
                  <Typography>{item.title}</Typography>
                </div>
              </div>
            );
          })} */}
          <Typography className="test-instruction-title">
            {step_guide}
          </Typography>
          <div className="steps-one">
            <Typography className="test-instruction-title">
              1. {step_one}
            </Typography>
            <img
              src={prerequisitesImg}
              alt="prerequisites"
              className="img one"
            />
            {prerequisitesStepsItem?.map((item, index) => {
              return (
                <div className="prerequisites-step" key={index}>
                  <Typography className="step-title">{item.title}</Typography>
                  <Typography className="description">
                    {item.description}
                  </Typography>
                </div>
              );
            })}
            <div className="test-step-divider"></div>
          </div>
          <div className="step-two">
            <Typography className="test-instruction-title">
              2. {step_two}
            </Typography>
            {locale === "en" ? (
              <img src={setupImg} alt="steup" className="img" />
            ) : (
              <img src={setupForJP} alt="steup" className="img" />
            )}
            <ul className="list-instruction">
              <li dangerouslySetInnerHTML={{ __html: setup1 }}></li>
              <li dangerouslySetInnerHTML={{ __html: setup2 }}></li>
              <li dangerouslySetInnerHTML={{ __html: setup3 }}></li>
              <li dangerouslySetInnerHTML={{ __html: setupnewAdd }}></li>
              <li>{setup4}</li>
            </ul>
            <div className="test-step-divider"></div>
          </div>
          <div className="step-three">
            <Typography className="test-instruction-title">
              3. {step_three}
            </Typography>
            <img src={performTestImg} alt="perform-test" className="img" />
            <ul className="list-instruction">
              <li dangerouslySetInnerHTML={{ __html: perform1 }}></li>
              <li dangerouslySetInnerHTML={{ __html: perform2 }}></li>
            </ul>
            <div className="test-step-divider"></div>
          </div>
          <div className="step-four">
            <Typography className="test-instruction-title">
              4. {step_four}
            </Typography>
            {locale === "en" ? (
              <img src={uploadImg} alt="steup" className="img" />
            ) : (
              <img src={uploadForJP} alt="steup" className="img" />
            )}
            <ul className="list-instruction">
              <li dangerouslySetInnerHTML={{ __html: upload1 }}></li>
              <li dangerouslySetInnerHTML={{ __html: upload2 }}></li>
            </ul>
          </div>
        </div>
      </div>
    </UserDetailsHeader>
  );
};

export default HowtoTestGaitAndBalance;
